// extracted by mini-css-extract-plugin
export default {"wrapper":"Window_wrapper__EEOkz","header":"Window_header__bLRj8","body":"Window_body__kp5Vi","footer":"Window_footer__eGoE2"};